<template>
  <base-message :message="message">
    <div class="text-message">
      网络异常！
    </div>
  </base-message>
</template>

<script>
  import BaseMessage from './BaseMessage'
  export default {
    components: {BaseMessage},
    props: ['message']
  }
</script>

<style lang="stylus" scoped>
  .text-message {
    padding .5em .75em
  }
</style>